"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.policyDescriptions = exports.Policies = void 0;
var Policies;
(function (Policies) {
    let COMPANY;
    (function (COMPANY) {
        COMPANY["ACCESS_COMPANY_SETTINGS"] = "COMPANY:ACCESS_COMPANY_SETTINGS";
        COMPANY["UPDATE_COMPANY_MAIN_INFO"] = "COMPANY:UPDATE_COMPANY_MAIN_INFO";
        COMPANY["MANAGE_KYC_STATUS"] = "COMPANY:MANAGE_KYC_STATUS";
        COMPANY["MANAGE_COMPANY_MODULES"] = "COMPANY:MANAGE_COMPANY_MODULES";
        COMPANY["MANAGE_BANK_ACCOUNTS"] = "COMPANY:MANAGE_BANK_ACCOUNTS";
        COMPANY["MANAGE_COMPANY_CUSTOMIZATION_SETTINGS"] = "COMPANY:MANAGE_COMPANY_CUSTOMIZATION_SETTINGS";
        COMPANY["MANAGE_COMPANY_REMINDERS_SETTINGS"] = "COMPANY:MANAGE_COMPANY_REMINDERS_SETTINGS";
        COMPANY["MANAGE_COMPANY_CURRENCY_SETTINGS"] = "COMPANY:MANAGE_COMPANY_CURRENCY_SETTINGS";
        COMPANY["MANAGE_SEGMENT_SETTINGS"] = "COMPANY:MANAGE_SEGMENT_SETTINGS";
        COMPANY["MANAGE_ORDER_SETTINGS"] = "COMPANY:MANAGE_ORDER_SETTINGS";
        COMPANY["ADMIN_ACCESS"] = "COMPANY:ADMIN_ACCESS";
    })(COMPANY = Policies.COMPANY || (Policies.COMPANY = {}));
    let COMPANY_BILLING;
    (function (COMPANY_BILLING) {
        COMPANY_BILLING["ACCESS_COMPANY_BILLING_SETTINGS"] = "COMPANY_BILLING:ACCESS_COMPANY_BILLING_SETTINGS";
        COMPANY_BILLING["RETRY_BILLING_PAYMENT"] = "COMPANY_BILLING:RETRY_BILLING_PAYMENT";
        COMPANY_BILLING["VIEW_PAYMENT_METHODS"] = "COMPANY_BILLING:VIEW_PAYMENT_METHODS";
        COMPANY_BILLING["MANAGE_PAYMENT_METHODS"] = "COMPANY_BILLING:MANAGE_PAYMENT_METHODS";
        COMPANY_BILLING["ADMIN_ACCESS"] = "COMPANY_BILLING:ADMIN_ACCESS";
    })(COMPANY_BILLING = Policies.COMPANY_BILLING || (Policies.COMPANY_BILLING = {}));
    let COMPANY_PLAN;
    (function (COMPANY_PLAN) {
        COMPANY_PLAN["ACCESS_COMPANY_PLAN_SETTINGS"] = "COMPANY_PLAN:ACCESS_COMPANY_PLAN_SETTINGS";
        COMPANY_PLAN["INCREASE_CURRENT_PLAN_LIMITS"] = "COMPANY_PLAN:INCREASE_CURRENT_PLAN_LIMITS";
        COMPANY_PLAN["CHANGE_COMPANY_PLAN"] = "COMPANY_PLAN:CHANGE_COMPANY_PLAN";
        COMPANY_PLAN["ADMIN_ACCESS"] = "COMPANY_PLAN:ADMIN_ACCESS";
    })(COMPANY_PLAN = Policies.COMPANY_PLAN || (Policies.COMPANY_PLAN = {}));
    let USER;
    (function (USER) {
        USER["UPDATE_OWN_USER_INFO"] = "USER:UPDATE_OWN_USER_INFO";
        USER["UPDATE_OWN_AUTHORIZATION_INFO"] = "USER:UPDATE_OWN_AUTHORIZATION_INFO";
        USER["LEAVE_COMPANY"] = "USER:LEAVE_COMPANY";
        USER["ADMIN_ACCESS"] = "USER:ADMIN_ACCESS";
    })(USER = Policies.USER || (Policies.USER = {}));
    let TEAM;
    (function (TEAM) {
        TEAM["VIEW_TEAM"] = "TEAM:VIEW_TEAM";
        TEAM["CREATE_USERS"] = "TEAM:CREATE_USERS";
        TEAM["MODIFY_PERSONAL_INFO"] = "TEAM:MODIFY_PERSONAL_INFO";
        TEAM["MODIFY_AUTHORIZATION_INFO"] = "TEAM:MODIFY_AUTHORIZATION_INFO";
        TEAM["MODIFY_ROLE"] = "TEAM:MODIFY_ROLE";
        TEAM["MARK_AS_INACTIVE"] = "TEAM:MARK_AS_INACTIVE";
        TEAM["DELETE_USERS"] = "TEAM:DELETE_USERS";
        TEAM["ADMIN_ACCESS"] = "TEAM:ADMIN_ACCESS";
    })(TEAM = Policies.TEAM || (Policies.TEAM = {}));
    let ROLE;
    (function (ROLE) {
        ROLE["VIEW_ROLES"] = "ROLE:VIEW_ROLES";
        ROLE["VIEW_OWN_ROLE"] = "ROLE:VIEW_OWN_ROLE";
        ROLE["CREATE_ROLES"] = "ROLE:CREATE_ROLES";
        ROLE["MODIFY_ROLE"] = "ROLE:MODIFY_ROLE";
        ROLE["DELETE_ROLES"] = "ROLE:DELETE_ROLES";
        ROLE["ADMIN_ACCESS"] = "ROLE:ADMIN_ACCESS";
    })(ROLE = Policies.ROLE || (Policies.ROLE = {}));
    let PRODUCT;
    (function (PRODUCT) {
        PRODUCT["VIEW_PRODUCTS"] = "PRODUCT:VIEW_PRODUCTS";
        PRODUCT["CREATE_PRODUCTS"] = "PRODUCT:CREATE_PRODUCTS";
        PRODUCT["MODIFY_INFO"] = "PRODUCT:MODIFY_INFO";
        PRODUCT["MODIFY_AVAILABILITY"] = "PRODUCT:MODIFY_AVAILABILITY";
        PRODUCT["MOIFY_PRICING"] = "PRODUCT:MODIFY_PRICING";
        PRODUCT["MODIFY_STOCK"] = "PRODUCT:MODIFY_STOCK";
        PRODUCT["DELETE_PRODUCTS"] = "PRODUCT:DELETE_PRODUCTS";
        PRODUCT["ADMIN_ACCESS"] = "PRODUCT:ADMIN_ACCESS";
    })(PRODUCT = Policies.PRODUCT || (Policies.PRODUCT = {}));
    let CATEGORY;
    (function (CATEGORY) {
        CATEGORY["VIEW_CATEGORIES"] = "CATEGORY:VIEW_CATEGORIES";
        CATEGORY["CREATE_CATEGORIES"] = "CATEGORY:CREATE_CATEGORIES";
        CATEGORY["UPDATE_CATEGORIES"] = "CATEGORY:UPDATE_CATEGORIES";
        CATEGORY["DELETE_CATEGORIES"] = "CATEGORY:DELETE_CATEGORIES";
        CATEGORY["ADMIN_ACCESS"] = "CATEGORY:ADMIN_ACCESS";
    })(CATEGORY = Policies.CATEGORY || (Policies.CATEGORY = {}));
    let BRAND;
    (function (BRAND) {
        BRAND["VIEW_BRANDS"] = "BRAND:VIEW_BRANDS";
        BRAND["CREATE_BRANDS"] = "BRAND:CREATE_BRANDS";
        BRAND["UPDATE_BRANDS"] = "BRAND:UPDATE_BRANDS";
        BRAND["DELETE_BRANDS"] = "BRAND:DELETE_BRANDS";
        BRAND["ADMIN_ACCESS"] = "BRAND:ADMIN_ACCESS";
    })(BRAND = Policies.BRAND || (Policies.BRAND = {}));
    let SUPPLIER;
    (function (SUPPLIER) {
        SUPPLIER["VIEW_SUPPLIERS"] = "SUPPLIER:VIEW_SUPPLIERS";
        SUPPLIER["CREATE_SUPPLIERS"] = "SUPPLIER:CREATE_SUPPLIERS";
        SUPPLIER["UPDATE_SUPPLIERS"] = "SUPPLIER:UPDATE_SUPPLIERS";
        SUPPLIER["DELETE_SUPPLIERS"] = "SUPPLIER:DELETE_SUPPLIERS";
        SUPPLIER["ADMIN_ACCESS"] = "SUPPLIER:ADMIN_ACCESS";
    })(SUPPLIER = Policies.SUPPLIER || (Policies.SUPPLIER = {}));
    let CUSTOMER;
    (function (CUSTOMER) {
        CUSTOMER["VIEW_CUSTOMERS"] = "CUSTOMER:VIEW_CUSTOMERS";
        CUSTOMER["CREATE_CUSTOMERS"] = "CUSTOMER:CREATE_CUSTOMERS";
        CUSTOMER["UPDATE_CUSTOMERS"] = "CUSTOMER:UPDATE_CUSTOMERS";
        CUSTOMER["DELETE_CUSTOMERS"] = "CUSTOMER:DELETE_CUSTOMERS";
        CUSTOMER["ADMIN_ACCESS"] = "CUSTOMER:ADMIN_ACCESS";
    })(CUSTOMER = Policies.CUSTOMER || (Policies.CUSTOMER = {}));
    let ORDER;
    (function (ORDER) {
        ORDER["VIEW_ORDERS"] = "ORDER:VIEW_ORDERS";
        ORDER["VIEW_OWN_ORDERS"] = "ORDER:VIEW_OWN_ORDERS";
        ORDER["CREATE_ORDERS"] = "ORDER:CREATE_ORDERS";
        ORDER["MODIFY_ORDERS"] = "ORDER:MODIFY_ORDERS";
        ORDER["MODIFY_PAYMENT_METHOD"] = "ORDER:MODIFY_PAYMENT_METHOD";
        ORDER["MODIFY_DELIVERY_INFO"] = "ORDER:MODIFY_DELIVERY_INFO";
        ORDER["CHANGE_ORDER_STATUS"] = "ORDER:CHANGE_ORDER_STATUS";
        ORDER["DELETE_ORDERS"] = "ORDER:DELETE_ORDERS";
        ORDER["ADMIN_ACCESS"] = "ORDER:ADMIN_ACCESS";
    })(ORDER = Policies.ORDER || (Policies.ORDER = {}));
    let API_KEY;
    (function (API_KEY) {
        API_KEY["VIEW_API_KEYS"] = "API_KEY:VIEW_API_KEYS";
        API_KEY["VIEW_SANDBOX_API_KEYS"] = "API_KEY:VIEW_SANDBOX_API_KEYS";
        API_KEY["CREATE_API_KEYS"] = "API_KEY:CREATE_API_KEYS";
        API_KEY["CREATE_SANDBOX_API_KEYS"] = "API_KEY:CREATE_SANDBOX_API_KEYS";
        API_KEY["UPDATE_API_KEY_INFO"] = "API_KEY:UPDATE_API_KEY_INFO";
        API_KEY["UPDATE_SANDBOX_API_KEY_INFO"] = "API_KEY:UPDATE_SANDBOX_API_KEY_INFO";
        API_KEY["UPDATE_API_KEY_POLICIES"] = "API_KEY:UPDATE_API_KEY_POLICIES";
        API_KEY["UPDATE_SANDBOX_API_KEY_POLICIES"] = "API_KEY:UPDATE_SANDBOX_API_KEY_POLICIES";
        API_KEY["UPDATE_API_KEY_STATUS"] = "API_KEY:UPDATE_API_KEY_STATUS";
        API_KEY["UPDATE_SANDBOX_API_KEY_STATUS"] = "API_KEY:UPDATE_SANDBOX_API_KEY_STATUS";
        API_KEY["DELETE_API_KEYS"] = "API_KEY:DELETE_API_KEYS";
        API_KEY["DELETE_SANDBOX_API_KEYS"] = "API_KEY:DELETE_SANDBOX_API_KEYS";
        API_KEY["ADMIN_ACCESS"] = "API_KEY:ADMIN_ACCESS";
        API_KEY["SANDBOX_ADMIN_ACCESS"] = "API_KEY:SANDBOX_ADMIN_ACCESS";
    })(API_KEY = Policies.API_KEY || (Policies.API_KEY = {}));
    let LOCATION;
    (function (LOCATION) {
        LOCATION["VIEW_LOCATIONS"] = "LOCATION:VIEW_LOCATIONS";
        LOCATION["VIEW_ASSIGNED_LOCATIONS"] = "LOCATION:VIEW_ASSIGNED_LOCATIONS";
        LOCATION["CREATE_LOCATIONS"] = "LOCATION:CREATE_LOCATIONS";
        LOCATION["UPDATE_LOCATION_INFO"] = "LOCATION:UPDATE_LOCATION_INFO";
        LOCATION["UPDATE_LOCATION_TEAM"] = "LOCATION:UPDATE_LOCATION_TEAM";
        LOCATION["UPDATE_LOCATION_STATUS"] = "LOCATION:UPDATE_LOCATION_STATUS";
        LOCATION["DELETE_LOCATIONS"] = "LOCATION:DELETE_LOCATIONS";
        LOCATION["ADMIN_ACCESS"] = "LOCATION:ADMIN_ACCESS";
    })(LOCATION = Policies.LOCATION || (Policies.LOCATION = {}));
    let TERMINAL;
    (function (TERMINAL) {
        TERMINAL["VIEW_TERMINALS"] = "TERMINAL:VIEW_TERMINALS";
        TERMINAL["CREATE_TERMINALS"] = "TERMINAL:CREATE_TERMINALS";
        TERMINAL["UPDATE_TERMINALS"] = "TERMINAL:UPDATE_TERMINALS";
        TERMINAL["DELETE_TERMINALS"] = "TERMINAL:DELETE_TERMINALS";
        TERMINAL["UPDATE_TERMINAL_TEAM"] = "TERMINAL:UPDATE_TERMINAL_TEAM";
        TERMINAL["ADMIN_ACCESS"] = "TERMINAL:ADMIN_ACCESS";
    })(TERMINAL = Policies.TERMINAL || (Policies.TERMINAL = {}));
    let STATISTICS;
    (function (STATISTICS) {
        STATISTICS["VIEW_DASHBOARD"] = "STATISTICS:VIEW_DASHBOARD";
        STATISTICS["VIEW_OWN_DASHBOARD"] = "STATISTICS:VIEW_OWN_DASHBOARD";
        STATISTICS["VIEW_FINANCIAL"] = "STATISTICS:VIEW_FINANCIAL";
        STATISTICS["VIEW_OWN_FINANCIAL"] = "STATISTICS:VIEW_OWN_FINANCIAL";
        STATISTICS["VIEW_SALES"] = "STATISTICS:VIEW_SALES";
        STATISTICS["VIEW_OWN_SALES"] = "STATISTICS:VIEW_OWN_SALES";
        STATISTICS["VIEW_ORDERS"] = "STATISTICS:VIEW_ORDERS";
        STATISTICS["VIEW_OWN_ORDERS"] = "STATISTICS:VIEW_OWN_ORDERS";
        STATISTICS["VIEW_PAYMENTS"] = "STATISTICS:VIEW_PAYMENTS";
        STATISTICS["VIEW_CARD_PAYMENTS"] = "STATISTICS:VIEW_CARD_PAYMENTS";
        STATISTICS["VIEW_OWN_PAYMENTS"] = "STATISTICS:VIEW_OWN_PAYMENTS";
        STATISTICS["VIEW_ALL"] = "STATISTICS:VIEW_ALL";
        STATISTICS["VIEW_OWN_ALL"] = "STATISTICS:VIEW_OWN_ALL";
    })(STATISTICS = Policies.STATISTICS || (Policies.STATISTICS = {}));
    let PAYMENT;
    (function (PAYMENT) {
        PAYMENT["VIEW_PAYMENTS"] = "PAYMENT:VIEW_PAYMENTS";
        PAYMENT["VIEW_OTHER_PAYMENTS"] = "PAYMENT:VIEW_OTHER_PAYMENTS";
        PAYMENT["VIEW_OWN_PAYMENTS"] = "PAYMENT:VIEW_OWN_PAYMENTS";
        PAYMENT["CREATE_PAYMENTS"] = "PAYMENT:CREATE_PAYMENTS";
        PAYMENT["INITIATE_REFUNDS"] = "PAYMENT:INITIATE_REFUNDS";
        PAYMENT["MODIFY_PAYMENTS"] = "PAYMENT:MODIFY_PAYMENTS";
        PAYMENT["CHANGE_PAYMENT_STATUS"] = "PAYMENT:CHANGE_PAYMENT_STATUS";
        PAYMENT["DELETE_PAYMENTS"] = "PAYMENT:DELETE_PAYMENTS";
        PAYMENT["ADMIN_ACCESS"] = "PAYMENT:ADMIN_ACCESS";
    })(PAYMENT = Policies.PAYMENT || (Policies.PAYMENT = {}));
    //   Warehouse manager
    // Access shipping setting settings
    // Assign order to pickers
    // Book consignments
    // Print despatch label
    // Generate and print manifesto
    // Manage pickers / add new pickers
    // Status update in Despatch tab
    // Warehouse worker (picker)
    // View order to be picked
    // Assign order to be picked to yourself
    // Mark product in orders as picked
    let WARHOUSE;
    (function (WARHOUSE) {
        WARHOUSE["ADMIN_ACCESS"] = "WARHOUSE:ADMIN_ACCESS";
        WARHOUSE["ACCESS_SHIPPING_SETTINGS"] = "WARHOUSE:ACCESS_SHIPPING_SETTINGS";
        WARHOUSE["ASSIGN_ORDER_TO_PICKERS"] = "WARHOUSE:ASSIGN_ORDER_TO_PICKERS";
        WARHOUSE["BOOK_CONSIGNMENTS"] = "WARHOUSE:BOOK_CONSIGNMENTS";
        WARHOUSE["PRINT_DESPATCH_LABEL"] = "WARHOUSE:PRINT_DESPATCH_LABEL";
        WARHOUSE["GENERATE_AND_PRINT_MANIFEST"] = "WARHOUSE:GENERATE_AND_PRINT_MANIFEST";
        WARHOUSE["MANAGE_PICKERS"] = "WARHOUSE:MANAGE_PICKERS";
        WARHOUSE["STATUS_UPDATE_IN_DESPATCH_TAB"] = "WARHOUSE:STATUS_UPDATE_IN_DESPATCH_TAB";
        WARHOUSE["VIEW_ORDER_TO_BE_PICKED"] = "WARHOUSE:VIEW_ORDER_TO_BE_PICKED";
        WARHOUSE["ASSIGN_ORDER_TO_BE_PICKED_TO_YOURSELF"] = "WARHOUSE:ASSIGN_ORDER_TO_BE_PICKED_TO_YOURSELF";
        WARHOUSE["MARK_PRODUCT_IN_ORDERS_AS_PICKED"] = "WARHOUSE:MARK_PRODUCT_IN_ORDERS_AS_PICKED";
    })(WARHOUSE = Policies.WARHOUSE || (Policies.WARHOUSE = {}));
    let INCOMING_INVENTORY;
    (function (INCOMING_INVENTORY) {
        INCOMING_INVENTORY["VIEW_INCOMING_INVENTORY"] = "INCOMING_INVENTORY:VIEW_INCOMING_INVENTORY";
        INCOMING_INVENTORY["CREATE_TRANSFER"] = "INCOMING_INVENTORY:CREATE_TRANSFER";
        INCOMING_INVENTORY["CREATE_PURCHASE_ORDER"] = "INCOMING_INVENTORY:CREATE_PURCHASE_ORDER";
        INCOMING_INVENTORY["MODIFY_TRANSFER"] = "INCOMING_INVENTORY:MODIFY_TRANSFER";
        INCOMING_INVENTORY["MODIFY_PURCHASE_ORDER"] = "INCOMING_INVENTORY:MODIFY_PURCHASE_ORDER";
        INCOMING_INVENTORY["DELETE_TRANSFER"] = "INCOMING_INVENTORY:DELETE_TRANSFER";
        INCOMING_INVENTORY["DELETE_PURCHASE_ORDER"] = "INCOMING_INVENTORY:DELETE_PURCHASE_ORDER";
        INCOMING_INVENTORY["ADMIN_ACCESS"] = "INCOMING_INVENTORY:ADMIN_ACCESS";
    })(INCOMING_INVENTORY = Policies.INCOMING_INVENTORY || (Policies.INCOMING_INVENTORY = {}));
    let INVOICE;
    (function (INVOICE) {
        INVOICE["VIEW_INVOICES"] = "INVOICE:VIEW_INVOICES";
        INVOICE["CREATE_INVOICES"] = "INVOICE:CREATE_INVOICES";
        INVOICE["MODIFY_INVOICES"] = "INVOICE:MODIFY_INVOICES";
        INVOICE["CHANGE_INVOICE_STATUS"] = "INVOICE:CHANGE_INVOICE_STATUS";
        INVOICE["DELETE_INVOICE"] = "INVOICE:DELETE_INVOICE";
        INVOICE["ADMIN_ACCESS"] = "INVOICE:ADMIN_ACCESS";
    })(INVOICE = Policies.INVOICE || (Policies.INVOICE = {}));
    let INTEGRATIONS;
    (function (INTEGRATIONS) {
        INTEGRATIONS["VIEW_INTEGRATIONS"] = "INTEGRATIONS:VIEW_INTEGRATIONS";
        INTEGRATIONS["CREATE_INTEGRATIONS"] = "INTEGRATIONS:CREATE_INTEGRATIONS";
        INTEGRATIONS["MODIFY_INTEGRATIONS"] = "INTEGRATIONS:MODIFY_INTEGRATIONS";
        INTEGRATIONS["DELETE_INTEGRATIONS"] = "INTEGRATIONS:DELETE_INTEGRATIONS";
        INTEGRATIONS["ADMIN_ACCESS"] = "INTEGRATIONS:ADMIN_ACCESS";
    })(INTEGRATIONS = Policies.INTEGRATIONS || (Policies.INTEGRATIONS = {}));
    let APPS;
    (function (APPS) {
        APPS["ADMIN_ACCESS"] = "APPS:ADMIN_ACCESS";
        APPS["VIEW_APPS"] = "APPS:VIEW_APPS";
        APPS["CREATE_APPS"] = "APPS:CREATE_APPS";
        APPS["MODIFY_APPS"] = "APPS:MODIFY_APPS";
        APPS["DELETE_APPS"] = "APPS:DELETE_APPS";
    })(APPS = Policies.APPS || (Policies.APPS = {}));
    let PARTNER;
    (function (PARTNER) {
        PARTNER["ACCESS_PARTNER_MODULE"] = "PARTNER:ACCESS_PARTNER_MODULE";
        PARTNER["VIEW_DASHBOARD"] = "PARTNER:VIEW_DASHBOARD";
        PARTNER["VIEW_MANAGED_COMPANIES"] = "PARTNER:VIEW_MANAGED_COMPANIES";
        PARTNER["CREATE_MANAGED_COMPANIES"] = "PARTNER:CREATE_MANAGED_COMPANIES";
        PARTNER["MODIFY_MANAGED_COMPANIES"] = "PARTNER:MODIFY_MANAGED_COMPANIES";
        PARTNER["MANAGE_MANAGED_COMPANY_ACCESS"] = "PARTNER:MANAGE_MANAGED_COMPANY_ACCESS";
        //bank accounts
        PARTNER["VIEW_MANAGED_COMPANIES_BANK_ACCOUNTS"] = "PARTNER:VIEW_MANAGED_COMPANIES_BANK_ACCOUNTS";
        PARTNER["CREATE_MANAGED_COMPANIES_BANK_ACCOUNT"] = "PARTNER:CREATE_MANAGED_COMPANIES_BANK_ACCOUNT";
        PARTNER["MODIFY_MANAGED_COMPANIES_BANK_ACCOUNT"] = "PARTNER:MODIFY_MANAGED_COMPANIES_BANK_ACCOUNT";
        PARTNER["DELETE_MANAGED_COMPANIES_BANK_ACCOUNT"] = "PARTNER:DELETE_MANAGED_COMPANIES_BANK_ACCOUNT";
        //integrations
        PARTNER["VIEW_MANAGED_COMPANIES_INTEGRATIONS"] = "PARTNER:VIEW_MANAGED_COMPANIES_INTEGRATIONS";
        PARTNER["CREATE_MANAGED_COMPANIES_INTEGRATIONS"] = "PARTNER:CREATE_MANAGED_COMPANIES_INTEGRATIONS";
        PARTNER["MODIFY_MANAGED_COMPANIES_INTEGRATIONS"] = "PARTNER:MODIFY_MANAGED_COMPANIES_INTEGRATIONS";
        PARTNER["DELETE_MANAGED_COMPANIES_INTEGRATIONS"] = "PARTNER:DELETE_MANAGED_COMPANIES_INTEGRATIONS";
        //team
        PARTNER["VIEW_MANAGED_COMPANIES_TEAM"] = "PARTNER:VIEW_MANAGED_COMPANIES_TEAM";
        //officers
        PARTNER["VIEW_MANAGED_COMPANIES_OFFICERS"] = "PARTNER:VIEW_MANAGED_COMPANIES_OFFICERS";
        PARTNER["VIEW_MANAGED_COMPANIES_TRANSACTIONS"] = "PARTNER:VIEW_MANAGED_COMPANIES_TRANSACTIONS";
        PARTNER["ADMIN_ACCESS"] = "PARTNER:ADMIN_ACCESS";
    })(PARTNER = Policies.PARTNER || (Policies.PARTNER = {}));
    let PARTNER_API_PAYMENT;
    (function (PARTNER_API_PAYMENT) {
        PARTNER_API_PAYMENT["VIEW_PARTNER_API_PAYMENTS"] = "PARTNER_API_PAYMENT:VIEW_PARTNER_API_PAYMENTS";
        PARTNER_API_PAYMENT["CREATE_PARTNER_API_PAYMENTS"] = "PARTNER_API_PAYMENT:CREATE_PARTNER_API_PAYMENTS";
        PARTNER_API_PAYMENT["MODIFY_PARTNER_API_PAYMENTS"] = "PARTNER_API_PAYMENT:MODIFY_PARTNER_API_PAYMENTS";
        PARTNER_API_PAYMENT["DELETE_PARTNER_API_PAYMENTS"] = "PARTNER_API_PAYMENT:DELETE_PARTNER_API_PAYMENTS";
        PARTNER_API_PAYMENT["ADMIN_ACCESS"] = "PARTNER_API_PAYMENT:ADMIN_ACCESS";
    })(PARTNER_API_PAYMENT = Policies.PARTNER_API_PAYMENT || (Policies.PARTNER_API_PAYMENT = {}));
    let PARTNER_API_DATA_API;
    (function (PARTNER_API_DATA_API) {
        PARTNER_API_DATA_API["VIEW_CONSENTS"] = "PARTNER_API_DATA_API:VIEW_CONSENTS";
        PARTNER_API_DATA_API["CREATE_CONSENTS"] = "PARTNER_API_DATA_API:CREATE_CONSENTS";
        PARTNER_API_DATA_API["MANAGE_CONSENTS"] = "PARTNER_API_DATA_API:MANAGE_CONSENTS";
        PARTNER_API_DATA_API["VIEW_TRANSACTIONS"] = "PARTNER_API_DATA_API:VIEW_TRANSACTIONS";
        PARTNER_API_DATA_API["ADMIN_ACCESS"] = "PARTNER_API_DATA_API:ADMIN_ACCESS";
    })(PARTNER_API_DATA_API = Policies.PARTNER_API_DATA_API || (Policies.PARTNER_API_DATA_API = {}));
    let COMMERCIAL_INVOICES;
    (function (COMMERCIAL_INVOICES) {
        COMMERCIAL_INVOICES["VIEW_COMMERCIAL_INVOICES"] = "COMMERCIAL_INVOICES:VIEW_COMMERCIAL_INVOICES";
        COMMERCIAL_INVOICES["CREATE_COMMERCIAL_INVOICES"] = "COMMERCIAL_INVOICES:CREATE_COMMERCIAL_INVOICES";
        COMMERCIAL_INVOICES["MODIFY_COMMERCIAL_INVOICES"] = "COMMERCIAL_INVOICES:MODIFY_COMMERCIAL_INVOICES";
        COMMERCIAL_INVOICES["DELETE_COMMERCIAL_INVOICES"] = "COMMERCIAL_INVOICES:DELETE_COMMERCIAL_INVOICES";
        COMMERCIAL_INVOICES["ADMIN_ACCESS"] = "COMMERCIAL_INVOICES:ADMIN_ACCESS";
    })(COMMERCIAL_INVOICES = Policies.COMMERCIAL_INVOICES || (Policies.COMMERCIAL_INVOICES = {}));
    let DATA_API;
    (function (DATA_API) {
        DATA_API["VIEW_CONSENTS"] = "DATA_API:VIEW_CONSENTS";
        DATA_API["CREATE_CONSENTS"] = "DATA_API:CREATE_CONSENTS";
        DATA_API["MANAGE_CONSENTS"] = "DATA_API:MANAGE_CONSENTS";
        DATA_API["VIEW_TRANSACTIONS"] = "DATA_API:VIEW_TRANSACTIONS";
        DATA_API["ADMIN_ACCESS"] = "DATA_API:ADMIN_ACCESS";
    })(DATA_API = Policies.DATA_API || (Policies.DATA_API = {}));
    let WALLET;
    (function (WALLET) {
        WALLET["VIEW_WALLETS"] = "WALLET:VIEW_WALLETS";
        WALLET["MANAGE_WALLETS"] = "WALLET:MANAGE_WALLETS";
        WALLET["MANAGE_WITHDRAWAL_ACCOUNT"] = "WALLET:MANAGE_WITHDRAWAL_ACCOUNT";
        WALLET["VIEW_WALLET_BALANCE"] = "WALLET:VIEW_WALLET_BALANCE";
        /** Live wallet (provider) transactions - full feed from the connected account */
        WALLET["VIEW_ALL_WALLET_TRANSACTIONS"] = "WALLET:VIEW_ALL_WALLET_TRANSACTIONS";
        /** Fena-stored (OB) transactions for wallet bank accounts (DB) */
        WALLET["VIEW_OB_WALLET_TRANSACTIONS"] = "WALLET:VIEW_OB_WALLET_TRANSACTIONS";
        WALLET["VIEW_PAYOUTS"] = "WALLET:VIEW_PAYOUTS";
        WALLET["INITIATE_REFUND"] = "WALLET:INITIATE_REFUND";
        WALLET["CONFIRM_REFUND"] = "WALLET:CONFIRM_REFUND";
        WALLET["INITIATE_MANUAL_WITHDRAWAL"] = "WALLET:INITIATE_MANUAL_WITHDRAWAL";
        WALLET["CONFIRM_MANUAL_WITHDRAWAL"] = "WALLET:CONFIRM_MANUAL_WITHDRAWAL";
        WALLET["INITIATE_TRANSFER"] = "WALLET:INITIATE_TRANSFER";
        WALLET["CONFIRM_TRANSFER"] = "WALLET:CONFIRM_TRANSFER";
        WALLET["RETRY_PAYOUT"] = "WALLET:RETRY_PAYOUT";
        WALLET["ADMIN_ACCESS"] = "WALLET:ADMIN_ACCESS";
    })(WALLET = Policies.WALLET || (Policies.WALLET = {}));
})(Policies = exports.Policies || (exports.Policies = {}));
exports.policyDescriptions = {
    //company details and settings
    [Policies.COMPANY.ACCESS_COMPANY_SETTINGS]: "Access company settings",
    [Policies.COMPANY.UPDATE_COMPANY_MAIN_INFO]: "Update business information",
    [Policies.COMPANY.MANAGE_KYC_STATUS]: "Access identity verification",
    [Policies.COMPANY.MANAGE_COMPANY_MODULES]: "Manage modules",
    [Policies.COMPANY.MANAGE_BANK_ACCOUNTS]: "Manage bank accounts",
    [Policies.COMPANY.ADMIN_ACCESS]: "Full access to company",
    [Policies.COMPANY.MANAGE_COMPANY_CUSTOMIZATION_SETTINGS]: "Manage company customization settings",
    [Policies.COMPANY.MANAGE_ORDER_SETTINGS]: "Manage order settings",
    [Policies.COMPANY.MANAGE_COMPANY_CURRENCY_SETTINGS]: "Manage company currency settings",
    [Policies.COMPANY.MANAGE_COMPANY_REMINDERS_SETTINGS]: "Manage company reminders settings",
    [Policies.COMPANY.MANAGE_SEGMENT_SETTINGS]: "Manage segment settings",
    //company plan
    [Policies.COMPANY_PLAN.ACCESS_COMPANY_PLAN_SETTINGS]: "Access payment plan settings",
    [Policies.COMPANY_PLAN.CHANGE_COMPANY_PLAN]: "Change payment plan",
    [Policies.COMPANY_PLAN.INCREASE_CURRENT_PLAN_LIMITS]: "Increase limits",
    [Policies.COMPANY_PLAN.ADMIN_ACCESS]: "Full access to the payment plan",
    //company billing
    [Policies.COMPANY_BILLING.ACCESS_COMPANY_BILLING_SETTINGS]: "Access billing settings",
    [Policies.COMPANY_BILLING.VIEW_PAYMENT_METHODS]: "View payment methods",
    [Policies.COMPANY_BILLING.MANAGE_PAYMENT_METHODS]: "Manage payment methods",
    [Policies.COMPANY_BILLING.RETRY_BILLING_PAYMENT]: "Retry failed payment",
    [Policies.COMPANY_BILLING.ADMIN_ACCESS]: "Full access to billing",
    //user
    [Policies.USER.UPDATE_OWN_USER_INFO]: "Update personal info",
    [Policies.USER.UPDATE_OWN_AUTHORIZATION_INFO]: "Update authorization methods",
    [Policies.USER.LEAVE_COMPANY]: "Leave the company",
    [Policies.USER.ADMIN_ACCESS]: "Full access to personal settings",
    //team
    [Policies.TEAM.VIEW_TEAM]: "View team members",
    [Policies.TEAM.CREATE_USERS]: "Add team members",
    [Policies.TEAM.MODIFY_PERSONAL_INFO]: "Modify team members' personal info",
    [Policies.TEAM.MODIFY_AUTHORIZATION_INFO]: "Modify team members' authorization info",
    [Policies.TEAM.MODIFY_ROLE]: "Modify team members' role",
    [Policies.TEAM.MARK_AS_INACTIVE]: "Mark team member as inactive",
    [Policies.TEAM.DELETE_USERS]: "Remove team members",
    [Policies.TEAM.ADMIN_ACCESS]: "Full access to teams",
    //role
    [Policies.ROLE.VIEW_ROLES]: "View roles",
    [Policies.ROLE.VIEW_OWN_ROLE]: "View own role",
    [Policies.ROLE.CREATE_ROLES]: "Create new roles",
    [Policies.ROLE.MODIFY_ROLE]: "Modify existing roles",
    [Policies.ROLE.DELETE_ROLES]: "Delete roles",
    [Policies.ROLE.ADMIN_ACCESS]: "Full access to roles",
    //product
    [Policies.PRODUCT.VIEW_PRODUCTS]: "View products",
    [Policies.PRODUCT.CREATE_PRODUCTS]: "Create products",
    [Policies.PRODUCT.MODIFY_INFO]: "Modify product info",
    [Policies.PRODUCT.MODIFY_STOCK]: "Modify product stock",
    [Policies.PRODUCT.MODIFY_AVAILABILITY]: "Modify product availability",
    [Policies.PRODUCT.MOIFY_PRICING]: "Modify product pricing",
    [Policies.PRODUCT.DELETE_PRODUCTS]: "Delete products",
    [Policies.PRODUCT.ADMIN_ACCESS]: "Full access to products",
    //category
    [Policies.CATEGORY.VIEW_CATEGORIES]: "View categories",
    [Policies.CATEGORY.CREATE_CATEGORIES]: "Create categories",
    [Policies.CATEGORY.UPDATE_CATEGORIES]: "Edit categories",
    [Policies.CATEGORY.DELETE_CATEGORIES]: "Delete categories",
    [Policies.CATEGORY.ADMIN_ACCESS]: "Full access to categories",
    //brand
    [Policies.BRAND.VIEW_BRANDS]: "View brands",
    [Policies.BRAND.CREATE_BRANDS]: "Create brands",
    [Policies.BRAND.UPDATE_BRANDS]: "Update brands",
    [Policies.BRAND.DELETE_BRANDS]: "Delete brands",
    [Policies.BRAND.ADMIN_ACCESS]: "Full access to brands",
    //supplier
    [Policies.SUPPLIER.VIEW_SUPPLIERS]: "View suppliers",
    [Policies.SUPPLIER.CREATE_SUPPLIERS]: "Create suppliers",
    [Policies.SUPPLIER.UPDATE_SUPPLIERS]: "Edit suppliers",
    [Policies.SUPPLIER.DELETE_SUPPLIERS]: "Remove suppliers",
    [Policies.SUPPLIER.ADMIN_ACCESS]: "Full access to suppliers",
    //customer
    [Policies.CUSTOMER.VIEW_CUSTOMERS]: "View customers",
    [Policies.CUSTOMER.CREATE_CUSTOMERS]: "Create customers",
    [Policies.CUSTOMER.UPDATE_CUSTOMERS]: "Edit customers",
    [Policies.CUSTOMER.DELETE_CUSTOMERS]: "Delete customers",
    [Policies.CUSTOMER.ADMIN_ACCESS]: "Full access to customers",
    //order
    [Policies.ORDER.VIEW_ORDERS]: "View orders",
    [Policies.ORDER.VIEW_OWN_ORDERS]: "View assigned orders",
    [Policies.ORDER.CREATE_ORDERS]: "Create orders",
    [Policies.ORDER.MODIFY_ORDERS]: "Edit orders",
    [Policies.ORDER.MODIFY_PAYMENT_METHOD]: "Edit order payment info",
    [Policies.ORDER.MODIFY_DELIVERY_INFO]: "Edit order delivery info",
    [Policies.ORDER.CHANGE_ORDER_STATUS]: "Change order status",
    [Policies.ORDER.DELETE_ORDERS]: "Delete orders",
    [Policies.ORDER.ADMIN_ACCESS]: "Full access to orders",
    //api key
    [Policies.API_KEY.VIEW_API_KEYS]: "View API keys",
    [Policies.API_KEY.VIEW_SANDBOX_API_KEYS]: "View sandbox API keys",
    [Policies.API_KEY.CREATE_API_KEYS]: "Create API keys",
    [Policies.API_KEY.CREATE_SANDBOX_API_KEYS]: "Create sandbox API keys",
    [Policies.API_KEY.UPDATE_API_KEY_INFO]: "Update API key info",
    [Policies.API_KEY.UPDATE_SANDBOX_API_KEY_INFO]: "Update sandbox API key info",
    [Policies.API_KEY.UPDATE_API_KEY_POLICIES]: "Update API key permissions",
    [Policies.API_KEY.UPDATE_SANDBOX_API_KEY_POLICIES]: "Update sandbox API key permissions",
    [Policies.API_KEY.UPDATE_API_KEY_STATUS]: "Update API key status",
    [Policies.API_KEY.UPDATE_SANDBOX_API_KEY_STATUS]: "Update sandbox API key status",
    [Policies.API_KEY.DELETE_API_KEYS]: "Delete API keys",
    [Policies.API_KEY.DELETE_SANDBOX_API_KEYS]: "Delete sandbox API keys",
    [Policies.API_KEY.ADMIN_ACCESS]: "Full access to API keys",
    [Policies.API_KEY.SANDBOX_ADMIN_ACCESS]: "Full access to sandbox API keys",
    //location
    [Policies.LOCATION.VIEW_LOCATIONS]: "View locations",
    [Policies.LOCATION.VIEW_ASSIGNED_LOCATIONS]: "View assigned locations",
    [Policies.LOCATION.CREATE_LOCATIONS]: "Create locations",
    [Policies.LOCATION.UPDATE_LOCATION_INFO]: "Update location info",
    [Policies.LOCATION.UPDATE_LOCATION_TEAM]: "Update location team",
    [Policies.LOCATION.UPDATE_LOCATION_STATUS]: "Update location status",
    [Policies.LOCATION.DELETE_LOCATIONS]: "Delete locations",
    [Policies.LOCATION.ADMIN_ACCESS]: "Full access to locations",
    //statistics
    [Policies.STATISTICS.VIEW_DASHBOARD]: "View company dashboard",
    [Policies.STATISTICS.VIEW_OWN_DASHBOARD]: "View personal dashboard",
    [Policies.STATISTICS.VIEW_FINANCIAL]: "View financial statistics",
    [Policies.STATISTICS.VIEW_OWN_FINANCIAL]: "View personal financial statistics",
    [Policies.STATISTICS.VIEW_SALES]: "View sales statistics",
    [Policies.STATISTICS.VIEW_OWN_SALES]: "View personal sales statistics",
    [Policies.STATISTICS.VIEW_ORDERS]: "View order statistics",
    [Policies.STATISTICS.VIEW_OWN_ORDERS]: "View personal order statistics",
    [Policies.STATISTICS.VIEW_PAYMENTS]: "View payment statistics",
    [Policies.STATISTICS.VIEW_OWN_PAYMENTS]: "View personal payment statistics",
    [Policies.STATISTICS.VIEW_ALL]: "Full access to company statistics",
    [Policies.STATISTICS.VIEW_OWN_ALL]: "Full access to personal statistics",
    [Policies.STATISTICS.VIEW_CARD_PAYMENTS]: "View card payments",
    //payments , recurring payments, transactions
    [Policies.PAYMENT.VIEW_PAYMENTS]: "View payments",
    [Policies.PAYMENT.VIEW_OWN_PAYMENTS]: "View assigned payments",
    [Policies.PAYMENT.VIEW_OTHER_PAYMENTS]: "View cash and other payments",
    [Policies.PAYMENT.CREATE_PAYMENTS]: "Create payments",
    [Policies.PAYMENT.INITIATE_REFUNDS]: "Initiate refunds",
    [Policies.PAYMENT.MODIFY_PAYMENTS]: "Edit payments",
    [Policies.PAYMENT.CHANGE_PAYMENT_STATUS]: "Edit payment status",
    [Policies.PAYMENT.DELETE_PAYMENTS]: "Delete payments",
    [Policies.PAYMENT.ADMIN_ACCESS]: "Full access to payments",
    //warehouse
    [Policies.WARHOUSE.ADMIN_ACCESS]: "Full access to warehouse and shipping",
    [Policies.WARHOUSE.ACCESS_SHIPPING_SETTINGS]: "Access shipping settings",
    [Policies.WARHOUSE.ASSIGN_ORDER_TO_PICKERS]: "Assign order to pickers",
    [Policies.WARHOUSE.BOOK_CONSIGNMENTS]: "Create consignments / labels",
    [Policies.WARHOUSE.PRINT_DESPATCH_LABEL]: "Print despatch label",
    [Policies.WARHOUSE.GENERATE_AND_PRINT_MANIFEST]: "Generate and print manifesto",
    [Policies.WARHOUSE.MANAGE_PICKERS]: "Manage pickers",
    [Policies.WARHOUSE.STATUS_UPDATE_IN_DESPATCH_TAB]: "Status update in Despatch tab",
    [Policies.WARHOUSE.VIEW_ORDER_TO_BE_PICKED]: "View orders to be picked",
    [Policies.WARHOUSE.ASSIGN_ORDER_TO_BE_PICKED_TO_YOURSELF]: "Assign order to be picked to yourself",
    [Policies.WARHOUSE.MARK_PRODUCT_IN_ORDERS_AS_PICKED]: "Mark product in orders as picked",
    //incoming inventory
    [Policies.INCOMING_INVENTORY.VIEW_INCOMING_INVENTORY]: "View incoming inventory",
    [Policies.INCOMING_INVENTORY.CREATE_TRANSFER]: "Create transfer",
    [Policies.INCOMING_INVENTORY.CREATE_PURCHASE_ORDER]: "Create purchase order",
    [Policies.INCOMING_INVENTORY.MODIFY_TRANSFER]: "Modify transfer",
    [Policies.INCOMING_INVENTORY.MODIFY_PURCHASE_ORDER]: "Modify purchase order",
    [Policies.INCOMING_INVENTORY.DELETE_TRANSFER]: "Delete transfer",
    [Policies.INCOMING_INVENTORY.DELETE_PURCHASE_ORDER]: "Delete purchase order",
    [Policies.INCOMING_INVENTORY.ADMIN_ACCESS]: "Full access to incoming inventory",
    //invoice
    [Policies.INVOICE.VIEW_INVOICES]: "View invoices",
    [Policies.INVOICE.CREATE_INVOICES]: "Create invoices",
    [Policies.INVOICE.MODIFY_INVOICES]: "Modify invoices",
    [Policies.INVOICE.CHANGE_INVOICE_STATUS]: "Change invoice status",
    [Policies.INVOICE.DELETE_INVOICE]: "Delete invoice",
    [Policies.INVOICE.ADMIN_ACCESS]: "Full access to invoices",
    //integrations
    [Policies.INTEGRATIONS.VIEW_INTEGRATIONS]: "View integrations",
    [Policies.INTEGRATIONS.CREATE_INTEGRATIONS]: "Create integrations",
    [Policies.INTEGRATIONS.MODIFY_INTEGRATIONS]: "Modify integrations",
    [Policies.INTEGRATIONS.DELETE_INTEGRATIONS]: "Delete integrations",
    [Policies.INTEGRATIONS.ADMIN_ACCESS]: "Full access to integrations",
    //partner
    [Policies.PARTNER.ACCESS_PARTNER_MODULE]: "Access partner module",
    [Policies.PARTNER.CREATE_MANAGED_COMPANIES]: "Create companies",
    [Policies.PARTNER.MANAGE_MANAGED_COMPANY_ACCESS]: "Manage company access",
    [Policies.PARTNER.CREATE_MANAGED_COMPANIES_BANK_ACCOUNT]: "Create bank accounts for companies",
    [Policies.PARTNER.DELETE_MANAGED_COMPANIES_BANK_ACCOUNT]: "Delete bank accounts for companies",
    [Policies.PARTNER.MODIFY_MANAGED_COMPANIES_BANK_ACCOUNT]: "Modify bank accounts for companies",
    [Policies.PARTNER.VIEW_DASHBOARD]: "View companies statistics",
    [Policies.PARTNER.VIEW_MANAGED_COMPANIES]: "View companies",
    [Policies.PARTNER.VIEW_MANAGED_COMPANIES_BANK_ACCOUNTS]: "View companies bank accounts",
    [Policies.PARTNER.VIEW_MANAGED_COMPANIES_OFFICERS]: "View companies officers",
    [Policies.PARTNER.VIEW_MANAGED_COMPANIES_TRANSACTIONS]: "View companies transactions",
    [Policies.PARTNER.MODIFY_MANAGED_COMPANIES]: "Modify companies",
    //integrations
    [Policies.PARTNER.VIEW_MANAGED_COMPANIES_INTEGRATIONS]: "View companies integrations",
    [Policies.PARTNER.CREATE_MANAGED_COMPANIES_INTEGRATIONS]: "Create companies integrations",
    [Policies.PARTNER.MODIFY_MANAGED_COMPANIES_INTEGRATIONS]: "Modify companies integrations",
    [Policies.PARTNER.DELETE_MANAGED_COMPANIES_INTEGRATIONS]: "Delete companies integrations",
    //partner team
    [Policies.PARTNER.VIEW_MANAGED_COMPANIES_TEAM]: "View companies team",
    [Policies.PARTNER.ADMIN_ACCESS]: "Full access to partner module",
    //partner api
    [Policies.PARTNER_API_PAYMENT.VIEW_PARTNER_API_PAYMENTS]: "View payments via Partner API",
    [Policies.PARTNER_API_PAYMENT.CREATE_PARTNER_API_PAYMENTS]: "Create payments via Partner API",
    [Policies.PARTNER_API_PAYMENT.MODIFY_PARTNER_API_PAYMENTS]: "Modify payments via Partner API",
    [Policies.PARTNER_API_PAYMENT.DELETE_PARTNER_API_PAYMENTS]: "Delete payments via Partner API",
    [Policies.PARTNER_API_PAYMENT.ADMIN_ACCESS]: "Full access to payments via Partner API",
    [Policies.PARTNER_API_DATA_API.VIEW_CONSENTS]: "View AIS consent requests via Partner API",
    [Policies.PARTNER_API_DATA_API.CREATE_CONSENTS]: "Create AIS consent requests via Partner API",
    [Policies.PARTNER_API_DATA_API.MANAGE_CONSENTS]: "Manage AIS consents (cancel, renew, resend) via Partner API",
    [Policies.PARTNER_API_DATA_API.VIEW_TRANSACTIONS]: "View AIS transactions and balances via Partner API",
    [Policies.PARTNER_API_DATA_API.ADMIN_ACCESS]: "Full access to Data API via Partner API",
    //commercial invoices
    [Policies.COMMERCIAL_INVOICES.VIEW_COMMERCIAL_INVOICES]: "View commercial invoices",
    [Policies.COMMERCIAL_INVOICES.CREATE_COMMERCIAL_INVOICES]: "Create commercial invoices",
    [Policies.COMMERCIAL_INVOICES.MODIFY_COMMERCIAL_INVOICES]: "Modify commercial invoices",
    [Policies.COMMERCIAL_INVOICES.DELETE_COMMERCIAL_INVOICES]: "Delete commercial invoices",
    [Policies.COMMERCIAL_INVOICES.ADMIN_ACCESS]: "Full access to commercial invoices",
    [Policies.TERMINAL.ADMIN_ACCESS]: "Full access to terminals",
    [Policies.TERMINAL.VIEW_TERMINALS]: "View terminals",
    [Policies.TERMINAL.CREATE_TERMINALS]: "Create terminals",
    [Policies.TERMINAL.UPDATE_TERMINALS]: "Update terminals",
    [Policies.TERMINAL.DELETE_TERMINALS]: "Delete terminals",
    [Policies.TERMINAL.UPDATE_TERMINAL_TEAM]: "Update terminal team",
    //apps
    [Policies.APPS.ADMIN_ACCESS]: "Full access to apps",
    [Policies.APPS.VIEW_APPS]: "View apps",
    [Policies.APPS.CREATE_APPS]: "Connect apps",
    [Policies.APPS.MODIFY_APPS]: "Modify apps",
    [Policies.APPS.DELETE_APPS]: "Delete apps",
    //data api
    [Policies.DATA_API.VIEW_CONSENTS]: "View AIS consent requests",
    [Policies.DATA_API.CREATE_CONSENTS]: "Create AIS consent requests",
    [Policies.DATA_API.MANAGE_CONSENTS]: "Manage AIS consents (cancel, renew, resend)",
    [Policies.DATA_API.VIEW_TRANSACTIONS]: "View AIS transactions and balances",
    [Policies.DATA_API.ADMIN_ACCESS]: "Full access to Data API",
    // wallet
    [Policies.WALLET.VIEW_WALLETS]: "View connected wallets",
    [Policies.WALLET.MANAGE_WALLETS]: "Connect, reconnect and disconnect wallets and manage wallet settings",
    [Policies.WALLET.MANAGE_WITHDRAWAL_ACCOUNT]: "Create, set or change the withdrawal bank account used for wallet payouts",
    [Policies.WALLET.VIEW_WALLET_BALANCE]: "View wallet balance",
    [Policies.WALLET.VIEW_ALL_WALLET_TRANSACTIONS]: "View live transactions from the wallet provider",
    [Policies.WALLET.VIEW_OB_WALLET_TRANSACTIONS]: "View Open Banking transactions associated with the wallet",
    [Policies.WALLET.VIEW_PAYOUTS]: "View wallet payouts",
    [Policies.WALLET.INITIATE_REFUND]: "Initiate a refund (requires confirmation to be submitted). Best to also enable View payments.",
    [Policies.WALLET.CONFIRM_REFUND]: "Confirm and submit a refund",
    [Policies.WALLET.ADMIN_ACCESS]: "Full access to wallets",
    [Policies.WALLET.INITIATE_MANUAL_WITHDRAWAL]: "Initiate a manual withdrawal",
    [Policies.WALLET.CONFIRM_MANUAL_WITHDRAWAL]: "Confirm and submit a manual withdrawal",
    [Policies.WALLET.INITIATE_TRANSFER]: "Initiate a transfer (requires confirmation to be submitted)",
    [Policies.WALLET.CONFIRM_TRANSFER]: "Confirm and submit a transfer",
    [Policies.WALLET.RETRY_PAYOUT]: "Retry a wallet payout (e.g. retry a withdrawal that could not be completed due to insufficient funds)",
};
